/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessCount } from '../../models/access-count';

export interface AccessCountsControllerGetInRange$Params {

/**
 * Only return access counts at or after this ISO 8601 date (defaults to 30 days ago)
 */
  from?: string;

/**
 * Only return access counts at or before this ISO 8601 date (defaults to now)
 */
  to?: string;
}

export function accessCountsControllerGetInRange(http: HttpClient, rootUrl: string, params?: AccessCountsControllerGetInRange$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AccessCount>>> {
  const rb = new RequestBuilder(rootUrl, accessCountsControllerGetInRange.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AccessCount>>;
    })
  );
}

accessCountsControllerGetInRange.PATH = '/access-counts';
